define("settings/components/migration-banner", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _object, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showBanner}}
    <div class="tAC--banner " data-test-id="banner">
      <div class="u--row">
        <div class="u--col__9">
          <h2 class="u--text--lg u--m__tb__sm">
            {{t "account.migration_banner.title"}}
          </h2>
          <p class="u--text--md">
            {{html-safe (t "account.migration_banner.description")}}
          </p>
          <ul class="u--listUnstyle u--row u--row--noCollapse u--p__t__xs">
            <li class="u--col__4 u--p__b__xs">{{svg-jar "verified" class="o--icon u--m__r__xs"}}{{t "account.migration_banner.feature_1"}}</li>
            <li class="u--col__8 u--p__b__xs">{{svg-jar "verified" class="o--icon u--m__r__xs"}}{{t "shared_phrases.search_profile"}}</li>
            <li class="u--col__4 u--p__b__xs">{{svg-jar "verified" class="o--icon u--m__r__xs"}}{{t "account.migration_banner.feature_3"}}</li>
            <li class="u--col__8 u--p__b__xs">{{svg-jar "verified" class="o--icon u--m__r__xs"}}{{t "account.migration_banner.feature_4"}}</li>
          </ul>
          <div class="u--block u--m__t">
            <Shared::Button::Upgrade
              class="u--m__r qa--settings__button--upgrade"
              @location="subscription overview"
              @text={{t "account.migration_banner.button_plan"}}
              @feature="migrate"
              @track={{fn this.trackMigrationBanner "switch_new_plan"}}
            />
            <Shared::Link
              {{button type="outline"}}
              @href="https://help.later.com/hc/articles/1500004211501"
              @text={{t "account.migration_banner.button_compare"}}
              {{on "click" (fn this.trackMigrationBanner "compare_plans")}}
            />
          </div>
        </div>
      </div>
    </div>
  {{/if}}
  
  */
  {
    "id": "YNDs+YRj",
    "block": "[[[41,[30,0,[\"showBanner\"]],[[[1,\"  \"],[10,0],[14,0,\"tAC--banner \"],[14,\"data-test-id\",\"banner\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--col__9\"],[12],[1,\"\\n        \"],[10,\"h2\"],[14,0,\"u--text--lg u--m__tb__sm\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.migration_banner.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[[28,[37,1],[\"account.migration_banner.description\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--row u--row--noCollapse u--p__t__xs\"],[12],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--col__4 u--p__b__xs\"],[12],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,[28,[35,1],[\"account.migration_banner.feature_1\"],null]],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--col__8 u--p__b__xs\"],[12],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,[28,[35,1],[\"shared_phrases.search_profile\"],null]],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--col__4 u--p__b__xs\"],[12],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,[28,[35,1],[\"account.migration_banner.feature_3\"],null]],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--col__8 u--p__b__xs\"],[12],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,[28,[35,1],[\"account.migration_banner.feature_4\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--block u--m__t\"],[12],[1,\"\\n          \"],[8,[39,4],[[24,0,\"u--m__r qa--settings__button--upgrade\"]],[[\"@location\",\"@text\",\"@feature\",\"@track\"],[\"subscription overview\",[28,[37,1],[\"account.migration_banner.button_plan\"],null],\"migrate\",[28,[37,5],[[30,0,[\"trackMigrationBanner\"]],\"switch_new_plan\"],null]]],null],[1,\"\\n          \"],[8,[39,6],[[4,[38,7],null,[[\"type\"],[\"outline\"]]],[4,[38,8],[\"click\",[28,[37,5],[[30,0,[\"trackMigrationBanner\"]],\"compare_plans\"],null]],null]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/1500004211501\",[28,[37,1],[\"account.migration_banner.button_compare\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"t\",\"html-safe\",\"svg-jar\",\"shared/button/upgrade\",\"fn\",\"shared/link\",\"button\",\"on\"]]",
    "moduleName": "settings/components/migration-banner.hbs",
    "isStrictMode": false
  });

  let MigrationBannerComponent = (_class = class MigrationBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "segment", _descriptor2, this);

      _initializerDefineProperty(this, "store", _descriptor3, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor4, this);
    }

    get showBanner() {
      return this.auth.currentAccount.isOnLegacyPlan && this.auth.currentUserModel.isAccountOwner && !this.auth.currentAccount.pricingV1Free;
    }

    get subscription() {
      return this.subscriptions.subscription;
    }

    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }

    trackMigrationBanner(buttonText) {
      this.segment.track('clicked-legacy-migration-banner', {
        button_text: buttonText,
        plan_interval: this.subscriptionPlan.interval,
        plan_scheduled_end: this.subscription.activeUntil,
        plan_start: this.subscription.createdDate,
        user_id: this.auth.currentUserModel.id
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "trackMigrationBanner", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackMigrationBanner"), _class.prototype)), _class);
  _exports.default = MigrationBannerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MigrationBannerComponent);
});